export { default as InstagramCarrousel } from './InstagramCarrousel/InstagramCarrousel';
